import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Dialog, {DialogContent} from 'material-ui/Dialog'
import {LoadingIndicator} from '../../components'
import Typography from 'material-ui/Typography'
import Grid from './Grid'
import IconButton from "material-ui/IconButton";
import Close from "material-ui-icons/Close";

const ELEMENTS_TO_SHOW = 3

const styles = theme => ({
  dialog: {
    width: '100%',
    padding: 0,
    backgroundColor: theme.palette.background.modal,
  },
  container: {
    width: '100%',
    margin: 0,
  },
  item: {
    padding: '16px !important',
    background: 'rgba(0,0,0,.05)',
    border: 'solid 1px ' + theme.palette.border,
    overflowWrap: 'break-word',
  },
  imgContainer: {
    marginTop: 25,
    textAlign: 'center',
  },
  footerTop: {
    minHeight: 100,
    backgroundImage: 'url("/assets/costsCar.png")',
    backgroundRepeat: 'repeat',
    backgroundSize: 'auto 100%',
    backgroundPosition: 'center',
  },
  footerBottom: {
    height: 50,
    background: `linear-gradient(135deg, ${theme.palette.gradient.start} 0%, ${theme.palette.gradient.end} 100%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white'
  },
  iconButtonContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
  }
})

class Costs extends React.PureComponent {

  static displayName = 'Costs.component'

  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      picture: PropTypes.string.isRequired,
    })),
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
  }

  static defaultProps = {
    isLoading: false,
  }

  render() {
    const {classes, isOpen, items, isLoading, ...props} = this.props
    return (
      <div {...props}>
        <LoadingIndicator show={isLoading && isOpen}>
          <Dialog open={isOpen} onClose={this.props.onClose} maxWidth={'md'} fullWidth={true}>
            <DialogContent className={classes.dialog}>
              <div>
                <Typography variant={'subheading'} align={'center'} style={{fontWeight: 500}}>
                  Space Guru es claro:
                </Typography>
                <Typography variant={'subheading'} align={'center'} style={{fontWeight: 500, marginBottom: 30}}>
                  pagas por lo que guardas, una vez al mes.
                </Typography>
                <div className={classes.iconButtonContainer}>
                  <IconButton onClick={this.props.onClose}>
                    <Close/>
                  </IconButton>
                </div>
              </div>
              <Grid container className={classes.container}>
                {items.slice(0, ELEMENTS_TO_SHOW).map(i => (
                  <Grid item key={i.id} xs={12} sm={4} className={classes.item}>
                    <div className={classes.imgContainer}>
                      <img src={i.picture} alt={'-'} width={50} height={50} style={{objectFit: 'scale-down'}}/>
                    </div>
                    <Typography variant={'title'} color={'primary'} align={'center'} style={{fontWeight: 400}}>
                      ${i.price}/mes
                    </Typography>
                    <Typography variant={'body2'} color={'textSecondary'} align={'center'} style={{marginBottom: 15}}>
                      {i.name.toUpperCase()}
                    </Typography>
                    <Typography variant={'body1'} color={'textSecondary'} align={'center'} style={{marginBottom: 15}}>
                      {i.description}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
              <div className={classes.footerTop}/>
              <div className={classes.footerBottom}>
                <Typography variant={'body1'} align={'center'} style={{color: 'white'}}>
                  Tu primer retiro es gratis
                </Typography>
              </div>
            </DialogContent>
          </Dialog>
        </LoadingIndicator>
      </div>
    )
  }

}

export default withStyles(styles, {withTheme: true})(Costs)



// WEBPACK FOOTER //
// ./src/common/components/costs.jsx